import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import {
	Button,
	Card,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	maxWidth,
	minWidth,
	Button as OriginalButton,
	Text,
	TextButton,
	TextElements,
} from '@calm-web/design-system';

import { ContentWrapper } from '../shared/styles';
import { b2bRedemptionRevampContentMaxWidth } from '../utils';

export const Description = styled.div<{
	isRevampRedempFlow?: boolean;
}>`
	${ifProp(
		'isRevampRedempFlow',
		css`
			margin-top: 2px;
			margin-bottom: 30px;
		`,
	)}
	margin-top: 12px;
`;

export const SubmitButton = styled(Button)`
	width: 100%;
	min-width: 200px;
	margin: 16px auto;

	${minWidth('tablet')} {
		width: auto;
	}
`;

export const Help = styled.div`
	margin: 8px auto;
	width: 100%;
	text-align: left;
	${fontSize(FontSizes.base)}
	${fontWeight(FontWeights.Medium)};
`;

export const Legal = styled.div`
	font-style: italic;
	${fontSize(FontSizes.sm)};
`;

export const EligibilityContentWrapperRevamp = styled(Card)`
	padding: 28px 20px;
	border-radius: 20px;
	background-color: white;
	width: 100%;

	${minWidth('tablet')} {
		padding: 48px;
		width: 700px;
	}
`;

export const EligibilityContentWrapper = styled(ContentWrapper)`
	width: 100%;
`;

export const CtaText = styled(Text).attrs({
	el: TextElements.H1,
	weight: FontWeights.Medium,
	size: FontSizes.lg,
})`
	margin-top: 16px;
	text-align: left;
`;

export const AccessButton = styled(TextButton)`
	${fontSize(FontSizes.sm)}
`;

export const TwoColumnWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 20px;

	${minWidth('desktop')} {
		flex-direction: row;
		justify-content: space-evenly;
		align-items: flex-start;
		max-width: ${b2bRedemptionRevampContentMaxWidth};
		margin: auto;
		gap: 80px;
		min-height: inherit;
		padding: 0 20px;
	}

	${maxWidth('desktop')} {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
`;

export const FullWidthButton = styled(OriginalButton)`
	width: 100%;
`;

export const PageWrap = styled.div`
	min-height: calc(100vh - 40px);

	${maxWidth('tablet')} {
		padding-top: 0;

		> div {
			padding: 20px;
		}
	}
`;

export const InvalidIdentifier = styled.div`
	color: red;
	${fontSize(FontSizes.sm)};
	${fontWeight(FontWeights.Medium)};
	margin-top: 8px;
	margin-bottom: 16px;
`;

export const EligibilityTitle = styled(Text).attrs({
	el: 'h2',
	size: FontSizes['2xl'],
	weight: FontWeights.Medium,
	align: 'left',
})`
	margin-top: 0;
`;
